import React from "react";
import { cn } from "ui/lib/utils";

type SheetButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  /**
   * `primary` commits what the sheet is for (save, swap, show results) and is
   * volt. `secondary` is Done on a sheet that saves as you go, or an action
   * that leads somewhere else; it is grey, so volt always means "this commits".
   */
  kind: "primary" | "secondary";
};

/** A bottom sheet's footer action. */
export const SheetButton = ({
  kind,
  className,
  type = "button",
  ...props
}: SheetButtonProps) => (
  <button
    type={type}
    className={cn(
      "flex min-h-11 w-full items-center justify-center gap-2 rounded-xl px-4 text-[15px] font-semibold transition-colors disabled:opacity-40",
      kind === "primary"
        ? "bg-primary text-primary-foreground active:opacity-80"
        : "bg-white/[0.1] text-white active:bg-white/[0.16]",
      className
    )}
    {...props}
  />
);
